module.exports = __webpack_public_path__ + "img/hy.d7655bdf.png";